import { useLocation, useNavigate } from 'react-router-dom'
import { useMemo } from 'react'
import { createSearchParams, useSearchParams } from 'react-router'

interface NavigationConfig<T extends string> {
  basePath: string
  validTabs: T[]
  defaultTab: T
}

export const useTabNavigation = <T extends string>(config: NavigationConfig<T>) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const periodValue = searchParams.get('periodValue') || null

  const tab = useMemo<T>(() => {
    const lastSegment = pathname.split('/').pop() as T

    return config.validTabs.includes(lastSegment) ? lastSegment : config.defaultTab
  }, [pathname, config.validTabs, config.defaultTab])

  const onTabChange = (value: T) => {
    const params = periodValue ? { periodValue } : undefined
    void navigate({
      pathname: `${config.basePath}/${value}`,
      search: createSearchParams(params).toString(),
    })
  }

  return { tab, onTabChange }
}
